import React, { useState } from 'react';
import { ui } from './toolTheme';

const JsonFormatterPage = ({ setPage }) => {
  const [input, setInput] = useState('');
  const [output, setOutput] = useState('');
  const [error, setError] = useState('');

  const runFormat = () => {
    setError('');
    try {
      const parsed = JSON.parse(input);
      setOutput(JSON.stringify(parsed, null, 2));
    } catch (e) {
      setOutput('');
      setError(e.message || 'Invalid JSON');
    }
  };

  const minify = () => {
    setError('');
    try {
      const parsed = JSON.parse(input);
      setOutput(JSON.stringify(parsed));
    } catch (e) {
      setOutput('');
      setError(e.message || 'Invalid JSON');
    }
  };

  const copyOutput = async () => {
    if (!output) return;
    try { await navigator.clipboard.writeText(output); } catch {}
  };

  return (
    <main style={ui.page}>
      <div style={ui.container}>
        <button onClick={() => setPage('/tools')} style={ui.backBtn}>← Back to Tools</button>

        <div style={ui.card}>
          <h1 style={ui.sectionTitle}>JSON Formatter & Validator</h1>
          <p style={ui.sectionSub}>Validate, pretty-print, and minify JSON instantly.</p>
        </div>

        <div style={{ ...ui.card, marginTop: 18 }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
            <textarea value={input} onChange={(e) => setInput(e.target.value)} placeholder="Paste raw JSON" rows={16}
              style={{ ...ui.textarea, ...ui.mono, fontSize: 13 }} />
            <textarea value={output} readOnly placeholder="Formatted output" rows={16}
              style={{ ...ui.textarea, ...ui.mono, fontSize: 13 }} />
          </div>

          <div style={{ display: 'flex', gap: 10, marginTop: 12 }}>
            <button onClick={runFormat} style={ui.primaryBtn}>Format JSON</button>
            <button onClick={minify} style={ui.secondaryBtn}>Minify</button>
            <button onClick={copyOutput} style={ui.secondaryBtn}>Copy Output</button>
          </div>

          {error && <div style={ui.error}>{error}</div>}
        </div>
      </div>
    </main>
  );
};

export default JsonFormatterPage;
